import { reactive } from 'vue';
import { Traveller } from '../types';
import { Customer } from './useCustomer';

const state = reactive({
    enabled: false,
});
export const useDummyData = () => {
    const getDummyTraveller = (suffix?: number) => ({
        birthdate: '1986-12-13',
        first_name: `Peter ${suffix}`,
        last_name: 'Angelov',
        pickup_place: 'Piešťany',
    } as Traveller);

    const getDummyCustomer = () => ({
        first_name: 'Peter',
        last_name: 'Angelov',
        birthdate: '1986-12-13',
        id_card: 'EAS156',
        email: 'dummyemail@test.test',
        phone: '+421917919999',
        address_street: 'Address street',
        address_city: 'Address city',
        address_post_code: '90500',
        address_country: 'SK',
    } as Customer);

    return {
        dummyDataState: state,
        getDummyCustomer,
        getDummyTraveller,
    };
};
